import apiDietPaymentProcessor from "./apiDietPaymentProcessor"
import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

export default (commonBasicPlanCheckout) =>
  ({ successStepPath, failedStepPath }) => ({
    ...commonBasicPlanCheckout(),

    successStepPath: successStepPath,
    failedStepPath: failedStepPath,
    chosenPaymentMethod: null,
    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),

    init() {
      this.commonInit()

      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          this.isLoading = false
          this.chosenPaymentMethod = null
        }
      })

      if (this.store.isAbandonedBasket()) {
        this.updateOrderUtms()
      }
    },

    // Helper functions
    submitBasicPayment(paymentMethod) {
      this.chosenPaymentMethod = paymentMethod
      this.store.values.lastPaymentMethod = paymentMethod
      this.isLoading = true

      this.internalTracker.trackClick({
        clickName: (paymentMethod === "paypal_recurring" ? "PayPal" : "Credit Card") + " Selected"
      });

      const { handleCheckoutAndRedirect } = apiDietPaymentProcessor
      const checkoutParams = {
        successStepPath: this.successStepPath,
        failedStepPath: this.failedStepPath,
        paymentMethod: paymentMethod,
        restrictCardSave: true,
        checkoutTemplate: "yg-ac-pipe",
      }

      handleCheckoutAndRedirect(checkoutParams)
    },

    getSpinnerStatus(paymentMethod) {
      if (!this.isLoading) return false
      if (this.chosenPaymentMethod !== paymentMethod) return false

      return true
    },

    // Display old normal price for user
    getStandardPrice(offer) {
      return this.store.pricing.getPriceDataValue({ offer, dataKey: "price" })
    },
  })
